import React, { useState } from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import ListSchedule from './listSchedule'
import ScheduleSetting from './scheduleSetting'
import ServiceSetting from './ServiceSetting'
import ThoughtCalendar from './thoughtCalendar'
import AddBooking from "../AddBooking"
import LookSchedule from './lookSchedule'
import PendingSchedule from './pendingSchedule'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { USER_ROLES } from 'constants/permission'
import BasicTabs from 'components/BasicTabs'
import { ALL_PERMISSION } from 'constants/permission'
import { ROLE_ID_DIRECTOR } from 'constants/permission'

const { TabPane } = Tabs

export default function CustomerSchedule() {
  const params = useParams()
  const { t: translation } = useTranslation()
  const { search } = useLocation();
  const user = useSelector(state => state.member)
  const activeParmas = new URLSearchParams(search).get('active');

  const isAddBook = user.permissions.includes("ADD_SCHEDULE");
  const isAdmin = ROLE_ID_DIRECTOR === user.appUserRoleId;

  const listTab = [{
    key: "1",
    label :translation("listSchedules.listSchedules"),
    permission: undefined,
    component: <ListSchedule />
  },
  {
    key: "2",
    label :translation("landing.booking"),
    permission: ALL_PERMISSION.MANAGE_SCHEDULE.permissionTab.ADD_SCHEDULE.value,
    component: <AddBooking />

  },
  {
    key: "3",
    label :translation("thoughtCalendar.thoughtCalendar"),
    permission: undefined,
    component: <ThoughtCalendar />,
    condition: [isAdmin]
  },
  {
    key: "4",
    label :translation("scheduleSetting.scheduleSetting"),
    permission: undefined,
    component: <ScheduleSetting />,
    condition: [isAdmin]
  },
  {
    key: "5",
    label :translation("lookSchedule.lookSchedule"),
    permission: undefined,
    component: <LookSchedule />
  },
  {
    key: "6",
    label: translation("setting.service.service"),
    permission: undefined,
    component: <ServiceSetting />,
    condition: [isAdmin]
  },
  // {
  //   key: "6",
  //   label :translation("pendingSchedule.pendingSchedule"),
  //   permission: undefined,
  //   component: <PendingSchedule />
  // }
]

  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_SCHEDULE.permissionTab} />
  )

}
